import React, { useState, useEffect } from "react";
import authService from "../../services/authService";
import { getDeviceName } from "./DeviceName";
import { LoginBranding } from "./LoginBranding";
import { LoginForm } from "./LoginForm";
import { RecoverCredentialModal } from "./RecoverCredential";

const LoginPage: React.FC = () => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // 2. State για το αν είναι ανοιχτό το modal ή όχι
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("app-theme") || "teal";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const deviceName = getDeviceName();
      const deviceUserName = "WebUser";

      await authService.login({
        identifier: identifier.trim(),
        password: password,
        deviceName: deviceName,
        deviceUserName: deviceUserName,
      });

      window.location.href = "/";
    } catch (err: any) {
      setError(
        err.response?.data?.message ||
          "Λάθος στοιχεία σύνδεσης! Ελέγξτε το username/password."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-white relative">
      <LoginBranding />
      
      <LoginForm
        identifier={identifier}
        setIdentifier={setIdentifier}
        password={password}
        setPassword={setPassword}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        error={error}
        loading={loading}
        onSubmit={handleSubmit}
        onOpenModal={() => setIsModalOpen(true)} // <--- 3. Δίνουμε τη συνάρτηση για να ανοίγει το modal
      />

      {/* 4. Το Modal τοποθετείται εδώ για να εμφανίζεται πάνω από τη σελίδα */}
      <RecoverCredentialModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default LoginPage;